import React from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';

export const SuggestionsPanel = ({ 
  suggestions, 
  onSuggestionClick, 
  onClearSearch, 
  isQuerying,
  followUpRef,
  setFollowUpQuery,
  idx 
}) => {
  const isMobile = useIsMobile(640);
  
  if (!suggestions || suggestions.length === 0) return null;

  const handleClick = (suggestion) => {
    setFollowUpQuery(suggestion);
    setTimeout(() => {
      if (followUpRef?.current) {
        followUpRef.current.style.height = 'auto';
        followUpRef.current.style.height = followUpRef.current.scrollHeight + 'px';
        followUpRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      setTimeout(() => onSuggestionClick(suggestion), 300);
    }, 50);
  };

  return (
    <div className={`mt-4 mx-auto rounded-xl ${isMobile ? 'px-3 py-4' : 'px-6 py-5'} border border-gray-600/40 relative`} style={{ maxWidth: isMobile ? '100%' : '85%', backgroundColor: 'rgba(60, 65, 80, 0.5)', backdropFilter: 'blur(8px)' }} data-testid={`suggestions-${idx}`}>
      {/* D10.0 (Feb 24, 2026) — "Clear this Search" removed from this panel;
          it now lives at the top-level right-aligned position above (and
          renders for Demo results too, which don't have a SuggestionsPanel).
          Single source of truth for clear, no duplicate UI. */}
      <p className="text-gray-400 text-sm mb-3">Here's what I can do next:</p>
      <div className="space-y-2">
        {suggestions.map((suggestion, sIdx) => (
          <button
            key={sIdx}
            onClick={() => handleClick(suggestion)}
            disabled={isQuerying}
            className={`w-full text-left ${isMobile ? 'px-3 py-2' : 'px-4 py-3'} rounded-lg text-gray-200 text-sm leading-relaxed transition-all duration-200 hover:text-white disabled:opacity-50 hover:bg-cyan-500/10 hover:border-cyan-500/50 border border-transparent`}
            data-testid={`suggestion-btn-${idx}-${sIdx}`}
          >
            <span className="text-cyan-400 mr-2">{sIdx + 1}.</span>
            {suggestion}
          </button>
        ))}
      </div>
      <p className="mt-4 text-gray-500 text-sm italic">Or, if you would like me to do something else for you, just type what you want me to do below.</p>
    </div>
  );
};

export default SuggestionsPanel;
